import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Tooltip as MUITooltip } from '@material-ui/core';

import { ITooltipProps } from '../../constants/commonTypes';
import useWindowDimensions from '../../constants/utils';

const useStylesBootstrap = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
    width: "15em",
    padding: "12px"
  }
}));

const AxisTooltip = (props: any) => {
  const classes = useStylesBootstrap();
  return <MUITooltip arrow classes={classes} {...props} />;
}

const Tooltip = (props: ITooltipProps) => {
  const [tooltipPlacement, setTooltipPlacement] = useState('top')
  const { children, content, ...rest } = props;
  const { width } = useWindowDimensions()

  useEffect(() => {
    if (width <= 700) {
      setTooltipPlacement('left')
    } else {
      setTooltipPlacement('top')
    }
  }, [width])

  return (
    <AxisTooltip title={content} placement={tooltipPlacement} {...rest}>
      <div>{children}</div>
    </AxisTooltip>
  )
}

Tooltip.propTypes = {
  content: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  placement: PropTypes.string
}

Tooltip.defaultProps = {
  content: "",
  children: null,
  className: ""
}

export default Tooltip;